// Keeps the sticky product media locked from the very first scroll pixel.
// The media wrapper may start some pixels below the top of the page (spacers, announcement bar...);
// sticky `top: 0` only locks once the element reaches the viewport top, so the image would drift up
// by that offset first. We measure the offset and pull the sticky box up by the same amount.
(function () {
  function update() {
    var wrapper = document.querySelector('.product__media-wrapper');
    var gallery = wrapper && wrapper.querySelector('media-gallery.product__column-sticky');
    if (!gallery) return;
    var offset = Math.max(0, wrapper.getBoundingClientRect().top + window.scrollY);
    gallery.style.setProperty('--ws-sticky-offset', offset + 'px');
  }

  // Run as soon as the gallery is parsed, before its first paint.
  update();
  document.addEventListener('DOMContentLoaded', update);
  window.addEventListener('load', update);
  window.addEventListener('resize', update);
})();
